import { NavLink } from 'react-router-dom'
import { mainNavigation, siteConfig } from '../config/site'
import { LogoMark } from './LogoMark'

export function Footer() {
  const hasExternalLinks = Boolean(
    siteConfig.discordInviteUrl || siteConfig.contactEmail || siteConfig.socials.instagram || siteConfig.socials.tiktok,
  )

  return (
    <footer className="site-footer">
      <div className="shell site-footer__grid">
        <div>
          <LogoMark />
          <p className="site-footer__tagline">{siteConfig.tagline}</p>
          {hasExternalLinks && (
            <div className="site-footer__external" aria-label="Community links">
              {siteConfig.discordInviteUrl && <a href={siteConfig.discordInviteUrl} target="_blank" rel="noopener noreferrer">Discord</a>}
              {siteConfig.socials.instagram && <a href={siteConfig.socials.instagram} target="_blank" rel="noopener noreferrer">Instagram</a>}
              {siteConfig.socials.tiktok && <a href={siteConfig.socials.tiktok} target="_blank" rel="noopener noreferrer">TikTok</a>}
              {siteConfig.contactEmail && <a href={`mailto:${siteConfig.contactEmail}`}>Contact</a>}
            </div>
          )}
        </div>
        <nav className="site-footer__links" aria-label="Footer navigation">
          {mainNavigation.map((item) => <NavLink key={item.to} to={item.to}>{item.label}</NavLink>)}
          <NavLink to="/join">Join</NavLink>
        </nav>
      </div>
      <div className="shell site-footer__bottom">
        <p>© {new Date().getFullYear()} The Midnight Sanctuary.</p>
        <p>Made for cosy nights and magical minds.</p>
      </div>
    </footer>
  )
}
